export function colorHexAlpha (hex?: string, alpha?: number) {
  let r = 0
  let g = 0
  let b = 0

  if (hex && hex[0] === '#') {
    r = parseInt(hex.slice(1, 3), 16)
    g = parseInt(hex.slice(3, 5), 16)
    b = parseInt(hex.slice(5, 7), 16)
  }

  if (alpha !== undefined) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')'
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')'
  }
}



// WEBPACK FOOTER //
// ./src/utils/Color.ts